import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useWindowWidth } from 'src/useWindowWidth';
import { M } from 'src/Utils';
import { Input } from './Input';
import { Currency } from './Currency';
import { Column, BoxContainer, Title, Label, Wrapper } from '../styles';
import { Text } from './styles';
export var InputFilter = function (_a) {
    var filter = _a.filter, isPrice = _a.isPrice;
    var filters = filter.filters, title = filter.title;
    var windowWidth = useWindowWidth();
    var isMobile = windowWidth < M;
    var initial = isPrice ? { price_start: '', price_end: '' } : { code: '' };
    var _b = useState(initial), inputValues = _b[0], setInputValues = _b[1];
    var _c = useFormContext(), watch = _c.watch, setValue = _c.setValue, trigger = _c.trigger;
    var watchedFields = watch();
    var currency = watchedFields.currency;
    var isPriceDisabled = isPrice && !currency;
    var price_start = inputValues.price_start, price_end = inputValues.price_end;
    var handleSendInputValues = function () {
        setValue('price_start', price_start, { shouldValidate: false });
        setValue('price_end', price_end, { shouldValidate: false });
        trigger(['price_start', 'price_end']);
    };
    var isApplyActive = watchedFields.price_start !== price_start ||
        watchedFields.price_end !== price_end;
    return (React.createElement(BoxContainer, null,
        !isMobile && React.createElement(Title, null, title),
        isPrice && React.createElement(Currency, null),
        React.createElement(Wrapper, { gap: "16px", className: isPrice ? '' : 'column' }, filters.map(function (_a) {
            var title = _a.title, placeholder = _a.placeholder, property = _a.property;
            return (React.createElement(Column, { gap: "12px", key: property },
                React.createElement(Label, null, title),
                React.createElement(Input, { placeholder: placeholder, width: isPrice ? '64px' : 'auto', type: "text", property: property, inputValues: inputValues, setInputValues: setInputValues, setOnBlur: !isPrice, isPrice: isPrice, disabled: isPriceDisabled })));
        })),
        isPrice && (React.createElement(Text, { onClick: handleSendInputValues, className: isApplyActive ? 'isActive' : '' }, "Aplicar"))));
};
